<template>
	<div class="contact">
		<b-container class="container-lg mt-top text-left prl-outside">
		<b-row class="mb-3 top-text">{{$t('title')}}</b-row>
		<b-form inline enctype="multipart/form-data" @submit="sendContact" class="prl-inside">
			<b-row class="prl-inside">
				<p>{{$t('text1')}}</p>	
				<b-form-input id="name" name="name" class="w-100 mb-3" size="sm" v-model="message.name" required :placeholder="$t('name')"></b-form-input>
				<b-form-input id="email" name="email" type="email" class="w-100 mb-3" size="sm" v-model="message.email" required :placeholder="$t('email')"></b-form-input>
				<b-form-input id="phone" name="phone" class="w-100 mb-3" size="sm" v-model="message.phone" :placeholder="$t('phone')"></b-form-input>
				<b-form-textarea id="message" name="message" size="sm" rows="6" max-rows="6" v-model="message.text" :placeholder="$t('message')" class="mb-3 w-100"></b-form-textarea>
			<p>{{$t('addFiles')}}</p>
				<div v-if="message.files.length>0" class="w-100 pb-3">
					<ul class="m-0" style="list-style-type:none;">
						<li @click="removeAttachment(key)" v-for="(file, key) in message.files" :key="key" class="cursorp"><i class="fas fa-times mr-1" style="color:darkred"></i> {{file.name}}</li>
					</ul>
				</div>
				<b-form-file
					class="mb-4"
					size="sm"
					id="files"
					name="files"
					v-model="message.files"
					multiple
					accept=".jpg, .png, .docx, .pdf, .xlsx"
					:placeholder="$t('selectFile')"
				></b-form-file>
<!--				drop-placeholder="Datei hier ablegen ..."
					placeholder="Datei hochladen (oder legen Sie sie hier ab...)"
-->
				<vue-recaptcha
					:sitekey="$store.state.siteKey"
					ref="recaptcha"
					@verify="onCaptchaVerified"
					@expired="onCaptchaExpired"
					size="invisible"
				></vue-recaptcha>
				<b-button v-if="!uploading" class="gera-btn" variant="primary" type="submit">{{$t('send')}}</b-button>
				<b-button v-else class="gera-btn" style="width:300px;background-color: white !important;"><b-spinner variant="primary"></b-spinner></b-button>
				<p class="mt-2 fs07 text-center">{{$t('reCaptcha')}}<br>
				<a href="https://policies.google.com/privacy">{{$t('pp')}}</a> {{$t('and')}}
				<a href="https://policies.google.com/terms">{{$t('ts')}}</a>{{$t('apply')}}</p>
			</b-row>
		</b-form>
		</b-container>
		<div class="big-text text-left">{{$t('contact')}}</div>
		<app-modal width="350px" @closeModal="showMessage=false" v-show="showMessage">
		<div slot="title">
			<div class="float-left" :style="messageColor"><i class="fas fa-exclamation-circle fa-2x" :style="messageColor"></i></div><div class="float-left ml-2 modal-header-text" :style="messageColor">{{modalMessage}}</div>
		</div>
		<div slot="content" class="text-left bb-gera"></div>
		<div slot="buttons-right">
			<b-button class="btn-confirm" size="sm" @click="showMessage=false">{{$t('ok')}}</b-button>
		</div>
		</app-modal>
	</div>
</template>
<script>
import api from '@/components/backend-api';
import appModal from '@/components/Modal.vue';
import VueRecaptcha from 'vue-recaptcha';
export default {
	name: 'Contact',
	components: {
		appModal,
		VueRecaptcha
	},
	data () {
		return {
			uploading: false,
			status: '',
			sucessfulServerResponse: '',
			serverError: '',
  			showMessage: false,
			modalMessage: '',
			messageColor: 'color:#307bad',
			message: {
				name: '',
				email: '',
				phone: '',
				text: '',
				files: []
			}
		}
	},
	methods: {
		onCaptchaVerified (recaptchaToken) {
			this.$refs.recaptcha.reset();

			var formElement = document.querySelector('form');
			const fd = new FormData(formElement);
			fd.append('recaptchaToken', recaptchaToken);
			this.uploading = true;
			// console.log('recaptchaToken')
			// console.log(recaptchaToken)

			let modal = this.$store.state.modal;
			api.executePostServerAction('contact_handler.php', fd, false, true)
				.then(response => {
					 console.log('Response:');
					 console.log(response);
					 console.log(response.status);
					this.uploading = false;
					if (response.status == 200){
						 this.modalMessage=response.data.message;
						 this.messageColor='color:#307bad !important';
						 this.showMessage=true;
						modal.message = this.$t('thanks'); // + response.data.message;
						modal.color = 'color:#307bad !important';
						modal.type = 'warning';
						modal.show = true;

						this.message.name = '';
						this.message.email = '';
						this.message.phone = '';
						this.message.text = '';
						this.message.files = [];
						this.message.files.length = 0;
						
					} else {
						this.modalMessage=response.data.message;
						this.messageColor='color:darkred !important';
						this.showMessage=true;
					}
				})
				.catch(error => {
					console.log('Send contact error!');
					console.log('Error: ' + error);
					console.log(error.response);
					this.uploading = false;
					if (error.response !== undefined){
						modal.message = error.response.data.message;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
					} else {
						modal.message = error;
						modal.color = 'color:darkred !important';
						modal.type = 'warning';
						modal.show = true;
					}

//					this.message=error.response.data.message;
//					this.messageColor='color:darkred !important';
//					this.showMessage=true;
				})
		},
		onCaptchaExpired () {
			this.$refs.recaptcha.reset();
		},
		sendContact (evt) {
			evt.preventDefault();
			this.$refs.recaptcha.execute();
		},
		removeAttachment (index) {
			this.message.files.splice(index,1);
		}
	}
}
</script>
<style scoped>
	p {
		width: 100%;
		font-size: 0.9rem;
	}
</style>
<i18n>
	{
		"de": {
			"title": "Schreiben Sie uns!",
			"text1": "Mit * gekennzeichnete Felder sind Pflichtfelder",
			"name": "Name*",
			"email": "E-mail*",
			"phone": "Telefonnummer",
			"message": "Nachricht",
			"addFiles": "Datei hochladen:",
			"selectFile": "Datei auswahlen...",
			"send": "Abschicken",
			"thanks": "Wir danken für Ihre Nachricht und werden uns rasch um Ihr Anliegen bemühen.",
			"reCaptcha": "Diese Website ist durch reCAPTCHA geschützt und es gelten",
			"pp": "die Google-Datenschutzbestimmungen",
			"and": "und",
			"ts": "Nutzungsbedingungen",
			"apply": ".",
			"ok": "OK",
			"contact": "Kontakt"
		},
		"en": {
			"title": "Write us!",
			"text1": "Fields marked with an * are mandatory",
			"name": "Name*",
			"email": "E-mail*",
			"phone": "Phone number",
			"message": "Message",
			"addFiles": "Files to upload:",
			"selectFile": "Select file...",
			"send": "Send",
			"thanks": "We would like to thank you for your message and will answer your request as soon as possible.",
			"reCaptcha": "This site is protected by reCAPTCHA and the Google",
			"pp": "Privacy Policy",
			"and": "and",
			"ok": "OK",
			"ts": "Terms of Service",
			"apply": " apply.",
			"contact": "Contact"
		}
	}
</i18n>
